module.exports = __webpack_public_path__ + "img/quick_overview.c3d83474.jpg";